import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=4a767713&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=4a767713&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a767713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a767713')) {
      api.createRecord('4a767713', component.options)
    } else {
      api.reload('4a767713', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=4a767713&scoped=true", function () {
      api.rerender('4a767713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/didi/order/orderDetail.vue"
export default component.exports